import './gridMenuButton.less';

import React from 'react';
import { observer } from 'mobx-react';
import { MenuOutlined } from '@ant-design/icons';
import b_ from 'b_';

import { AntMenu } from 'controls/react/ant/antMenu';
import { GridMenuPlugin } from 'controls/grid/plugins/grid-menu/gridMenuPlugin';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { AntButton } from 'controls/react/ant/antButton';
import { AntPopover } from 'controls/react/ant/antPopover';
import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';

export type GridMenuButtonProps<DataItem extends GridDataEntry> = {
	store: GridStoreHolder<DataItem>;
};

const b = b_.with('grid-menu-button');

const selectedKeys: string[] = [];
export const GridMenuButton = observer(<DataItem extends GridDataEntry>(props: GridMenuButtonProps<DataItem>) => {
	const store = getStore(props.store);
	const [open, setOpen] = React.useState(false);

	if (store?.selfInitialized != true) return null;

	const plugin = store.plugins.find((x) => x.id == 'grid-menu') as GridMenuPlugin<DataItem>;

	if (plugin.config.mainMenu === false) return null;

	const items = plugin.generateContextMenu(
		plugin.store.selection,
		plugin.config.mainMenu === true ? '' : plugin.config.mainMenu,
	);

	const menu = (
		<AntMenu
			inlineIndent={16}
			className={b('menu')}
			onClick={async (item) => {
				setOpen(false);
				await plugin.onMenuItemClick(item, plugin.store.selection);
			}}
			mode={'inline'}
			items={items}
			//so the menu items are not selected on click
			selectedKeys={selectedKeys}
			triggerSubMenuAction={'click'}
		/>
	);

	return (
		//AntPopover's trigger doesn't forward a DOM ref, so this wrapper is what other actions
		//anchor their modals to via plugin.menuRef (see GridMenuActionArgs.menuRef)
		<span ref={plugin.menuRef}>
			<AntPopover
				trigger={'click'}
				open={open}
				onOpenChange={setOpen}
				arrow={false}
				placement={'rightTop'}
				content={menu}
			>
				<AntButton icon={<MenuOutlined />} />
			</AntPopover>
		</span>
	);
});

//@ts-expect-error an internal React property is not visible to TS for some reason
GridMenuButton.displayName = 'GridMenuButton';
